<template>
    <div class="mx-3">
        <div class="row border-bottom ml-1 mr-1">
            <div class="h2 col-6">{{ title }}</div>
        </div>
        <unsubmitted-documents-list :document-type-id="documentTypeId" :loading="loading" :documents="documents" @refresh="refresh"></unsubmitted-documents-list>                  
    </div>    
</template>

<script>
import UnsubmittedDocumentsList from './UnsubmittedDocumentsList.vue';

export default {
    components: {
        UnsubmittedDocumentsList
    },
    props: {
        documentTypeId: Number,
        title: String
    },
    data() {
         return {
             documents: [],
             loading: true
         }
    },  
    methods: {
        refresh: function () {
            
            this.loading = true;
            axios.get('/ajax/reports/unsubmitted/documents/' + this.documentTypeId)
                .then(response => {
                    this.documents = response.data.documents;
                    this.loading = false;
                });
        }
    },
    created() {
        this.refresh();

        // TODO : listen for events
    }    
}
</script>

<style scoped>

</style>